import DOMPurify from "isomorphic-dompurify";
import VueDOMPurifyHTML from "vue-dompurify-html";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(
    VueDOMPurifyHTML,
    {
      default: {
        ALLOWED_ATTR: [
          "aria-hidden",
          "class",
          "d",
          "href",
          "id",
          "onclick",
          "onmouseenter",
          "src",
          "style",
          "target",
          "type",
          "viewBox",
          "width",
          "rowspan",
        ],
      },
      enableSSRPropsSupport: true,
    },
    () => DOMPurify,
  );
});
